<template>
  <div class="colulmn-box">
    <div class="title-box auto boxsizing" v-if="!notitle">
      <slot name="title">
        <div class="title">
          <span class="font14 gray80">{{title}}</span>
          <el-tooltip class="item" effect="dark" v-if="tooltip" placement="top">
            <!-- <i class="el-icon-question tooltip-icon gray80"></i> -->
            <div slot="content" v-html="tooltip"></div>
            <i class="fa fa-question-circle-o gray80"></i>
          </el-tooltip>
        </div>
        <div class="title-right">
          <slot name="bar">
            <a v-if="link" :href="link" class="font12 gray80">更多>></a>
          </slot>
        </div>
      </slot>
    </div>
    <div class="clear"></div>
    <div class="content-box" :class="nomargin ? 'p-tb-30' : 'm-30'" :style="'height:' + nHeight">
      <slot name="content">
        <div class="content font14 gray80">
          <p>暂无内容</p>
        </div>
      </slot>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
export default {
  name: 'dufaultColumn',
  props: [
    'notitle',
    'title',
    'tooltip',
    'link',
    'height',
    'nomargin'
  ],
  data () {
    return {
      nHeight: this.height || '300px'
    }
  },
  methods: {},
  created () {
  }
}
</script>
<style scoped>
.colulmn-box {
  background: #fff;
  border-radius: 5px;
}
.title-box {
  width: 100%;
  padding: 30px 30px 0;
  line-height: 30px;
}
.title {
  float: left;
}
.title-right {
  float: right;
}
.content-box {
  /*width: 100%;*/
  position: relative;
  /*margin: 30px;*/
}
.content {
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.content p {
  position: absolute;
  top: 40%;
  width: 100%;
}
.p-tb-30 {
  padding: 30px 0;
}
</style>
